import axios from 'axios';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { toast } from 'sonner';
import { getCurrStock } from '../../../redux/actions/dataActions';
import { setOwnedStocks } from '../../../redux/actions/userActions';
import { isInvalidDate } from '../../../helpers/validDates';
import {
    TOURNAMENT_NOT_STARTED,
    getRoundName,
} from '../../../constants/constants';

class StockModal extends Component {
    state = {
        numToSell: '',
        sellPrice: '',
        numToBuy: '',
        numToIPOSell: '',
        buyIsLoading: false,
        currTab: 'quadrant',
        tradeMode: 'buy',
        tradeAmount: '',
    };

    constructor(props) {
        super(props);

        this.props.getCurrStock(
            this.props.data,
            this.props.data.filters,
            this.props.stockId
        );
        this.handleInputChange = this.handleInputChange.bind(this);
        this.getNumSharesOwned = this.getNumSharesOwned.bind(this);
        this.attemptToIPOBuy = this.attemptToIPOBuy.bind(this);
        this.attemptToIPOSell = this.attemptToIPOSell.bind(this);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.stockId !== this.props.stockId) {
            this.setState({ tradeMode: 'buy', tradeAmount: '' });
            this.props.getCurrStock(
                this.props.data,
                this.props.data.filters,
                this.props.stockId
            );
        }
    }

    getNumSharesOwned() {
        if (this.props.data.loading || this.props.user.loading)
            return 'Loading ...';
        else {
            if (!this.props.data.currStock?.stockData?.stockName) return 0;
            const foundStock = this.props.user.ownedStocks.find(
                (stock) =>
                    stock.stockName ===
                    this.props.data.currStock?.stockData?.stockName
            );
            if (foundStock) return foundStock.numShares;
            else return 0;
        }
    }

    attemptToIPOBuy = async () => {
        this.setState({ buyIsLoading: true });
        const amount = Number(this.state.numToBuy);
        const teamName = this.props.data.currStock?.stockData?.stockName || 'team';
        try {
            await axios({
                method: 'put',
                url: `/stocks/${this.props.stockId}/buyIpo`,
                data: { numShares: amount },
            });
            this.setState({ numToBuy: 0, tradeAmount: '' });
            await this.props.setOwnedStocks(this.props.user);
            await this.props.getCurrStock(
                this.props.data,
                this.props.data.filters,
                this.props.stockId
            );
            toast.success(`Invested $${amount} in ${teamName}`);
        } catch (err) {
            toast.error(err.response?.data?.error || 'Purchase failed. Please try again.');
        }
        this.setState({ buyIsLoading: false });
    };

    attemptToIPOSell = async () => {
        this.setState({ buyIsLoading: true });
        const amount = Number(this.state.numToSell);
        const teamName = this.props.data.currStock?.stockData?.stockName || 'team';
        try {
            await axios({
                method: 'put',
                url: `/stocks/${this.props.stockId}/sellIpo`,
                data: { numShares: amount },
            });
            this.setState({ numToSell: 0, tradeAmount: '' });
            await this.props.setOwnedStocks(this.props.user);
            await this.props.getCurrStock(
                this.props.data,
                this.props.data.filters,
                this.props.stockId
            );
            toast.success(`Sold $${amount} of ${teamName}`);
        } catch (err) {
            toast.error(err.response?.data?.error || 'Sale failed. Please try again.');
        }
        this.setState({ buyIsLoading: false });
    };
    handleInputChange = (name, value) => {
        this.setState({
            [name]: value,
        });
    };
    tabsToShow = [
        {
            value: 'quadrant',
            label: 'Quadrant',
        },
        {
            value: 'side',
            label: 'Side',
        },
        {
            value: 'full',
            label: 'Full',
        },
    ];

    render() {
        const numSharesOwned = this.props.user.ownedStocks
            ? this.getNumSharesOwned()
            : 0;

        const filename = this.props.data.currStock?.stockData?.imageUrl;
        const isOpen =
            this.props.stockId !== '' &&
            !this.props.data.currStockLoading &&
            this.props.data.currStock?.stockData;

        if (!isOpen) return null;

        return (
            <div className="fixed inset-0 z-50 overflow-y-auto">
                <div
                    className="fixed inset-0 bg-black/60 backdrop-blur-sm transition-opacity"
                    onClick={this.props.onClose}
                ></div>
                <div className="flex min-h-full items-center justify-center p-4">
                    <div className="relative w-full max-w-4xl max-h-[90vh] bg-slate-900/80 backdrop-blur-xl border border-slate-800 rounded-2xl shadow-2xl overflow-auto transform transition-all">
                        <button
                            onClick={this.props.onClose}
                            className="absolute top-4 right-4 z-10 p-2 text-slate-400 hover:text-white hover:bg-slate-800 rounded-lg transition-colors"
                        >
                            <svg
                                className="w-6 h-6"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={2}
                                    d="M6 18L18 6M6 6l12 12"
                                />
                            </svg>
                        </button>
                        <div className="p-6 md:p-8 text-white">
                            <div className="max-w-5xl mx-auto space-y-6">
                                {/* Header Section */}
                                <div className="text-center space-y-4">
                                    {this.props.data.loading ||
                                    !this.props.data.currStock?.stockData ? (
                                        <div className="flex justify-center py-8">
                                            <svg
                                                className="animate-spin h-8 w-8 text-blue-500"
                                                xmlns="http://www.w3.org/2000/svg"
                                                fill="none"
                                                viewBox="0 0 24 24"
                                            >
                                                <circle
                                                    className="opacity-25"
                                                    cx="12"
                                                    cy="12"
                                                    r="10"
                                                    stroke="currentColor"
                                                    strokeWidth="4"
                                                ></circle>
                                                <path
                                                    className="opacity-75"
                                                    fill="currentColor"
                                                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                                ></path>
                                            </svg>
                                        </div>
                                    ) : (
                                        <>
                                            <div className="flex items-center justify-center space-x-4">
                                                <h2 className="text-4xl font-bold text-white">
                                                    {
                                                        this.props.data
                                                            .currStock
                                                            ?.stockData
                                                            ?.stockName
                                                    }
                                                </h2>
                                                <img
                                                    className="w-16 h-16 rounded-lg bg-white p-2 border-2 border-slate-800"
                                                    src={filename}
                                                    alt="Team Logo"
                                                />
                                            </div>
                                            <div className="text-xl text-slate-300">
                                                <span className="font-semibold text-blue-400">
                                                    {
                                                        this.props.data
                                                            .currStock
                                                            ?.stockData?.seed
                                                    }
                                                </span>{' '}
                                                Seed (
                                                {
                                                    this.props.data.currStock
                                                        ?.stockData?.bio
                                                }
                                                )
                                            </div>
                                        </>
                                    )}
                                </div>

                                {!TOURNAMENT_NOT_STARTED && (
                                    <div className="text-center">
                                        <div className="text-2xl font-bold text-blue-400">
                                            {
                                                this.props.data.currStock
                                                    ?.stockData?.currPoints
                                            }{' '}
                                            Points
                                        </div>
                                        <div className="text-lg text-slate-300">
                                            (
                                            {this.props.data.currStock
                                                ?.stockData?.currPoints /
                                                this.props.data.currStock
                                                    ?.stockData?.seed}{' '}
                                            Win
                                            {this.props.data.currStock
                                                ?.stockData?.currPoints /
                                                this.props.data.currStock
                                                    ?.stockData?.seed !==
                                            1
                                                ? 's'
                                                : ''}
                                            )
                                        </div>
                                    </div>
                                )}

                                {/* Status badge - compact */}
                                {!this.props.data.loading && this.props.data.currStock?.stockData?.hasLost && (
                                    <div className="flex justify-center">
                                        <span className="text-xs font-semibold text-red-400 bg-red-500/10 border border-red-500/20 px-3 py-1 rounded-full">
                                            Eliminated
                                        </span>
                                    </div>
                                )}

                                {/* Buy/Sell Section */}
                                {this.props.user &&
                                this.props.user.authenticated &&
                                TOURNAMENT_NOT_STARTED ? (
                                    <div>
                                        {this.state.buyIsLoading ? (
                                            <div className="flex justify-center py-8">
                                                <svg
                                                    className="animate-spin h-8 w-8 text-blue-500"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    fill="none"
                                                    viewBox="0 0 24 24"
                                                >
                                                    <circle
                                                        className="opacity-25"
                                                        cx="12"
                                                        cy="12"
                                                        r="10"
                                                        stroke="currentColor"
                                                        strokeWidth="4"
                                                    ></circle>
                                                    <path
                                                        className="opacity-75"
                                                        fill="currentColor"
                                                        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                                    ></path>
                                                </svg>
                                            </div>
                                        ) : (
                                            <>
                                                {/* Stats bar */}
                                                <div className="flex items-center justify-center gap-6 mb-6 text-sm">
                                                    <div className="text-center">
                                                        <div className="text-[10px] uppercase tracking-wider text-slate-500 mb-0.5">Balance</div>
                                                        <div className="font-semibold text-emerald-400 tabular-nums">
                                                            ${this.props.user.loading || this.props.data.loading
                                                                ? '...'
                                                                : this.props.user.accountBalance.toFixed(2)}
                                                        </div>
                                                    </div>
                                                    <div className="w-px h-8 bg-slate-800" />
                                                    <div className="text-center">
                                                        <div className="text-[10px] uppercase tracking-wider text-slate-500 mb-0.5">Owned</div>
                                                        <div className="font-semibold text-blue-400 tabular-nums">${numSharesOwned}</div>
                                                    </div>
                                                    <div className="w-px h-8 bg-slate-800" />
                                                    <div className="text-center">
                                                        <div className="text-[10px] uppercase tracking-wider text-slate-500 mb-0.5">Per Win</div>
                                                        <div className="font-semibold text-orange-400">{this.props.data.currStock?.stockData?.seed}x</div>
                                                    </div>
                                                </div>

                                                {/* Trade card */}
                                                <div className="max-w-sm mx-auto bg-slate-950/60 border border-slate-800 rounded-xl p-4">
                                                    {/* Buy / Sell toggle — only show if they own shares */}
                                                    {numSharesOwned > 0 && (
                                                        <div className="flex rounded-lg bg-slate-900 p-0.5 mb-4">
                                                            <button
                                                                className={`flex-1 py-2 text-sm font-medium rounded-md transition-all ${
                                                                    this.state.tradeMode === 'buy'
                                                                        ? 'bg-emerald-500 text-white shadow-sm'
                                                                        : 'text-slate-400 hover:text-white'
                                                                }`}
                                                                onClick={() => this.setState({ tradeMode: 'buy', tradeAmount: '' })}
                                                            >
                                                                Buy
                                                            </button>
                                                            <button
                                                                className={`flex-1 py-2 text-sm font-medium rounded-md transition-all ${
                                                                    this.state.tradeMode === 'sell'
                                                                        ? 'bg-red-500 text-white shadow-sm'
                                                                        : 'text-slate-400 hover:text-white'
                                                                }`}
                                                                onClick={() => this.setState({ tradeMode: 'sell', tradeAmount: '' })}
                                                            >
                                                                Sell
                                                            </button>
                                                        </div>
                                                    )}

                                                    {/* Amount input */}
                                                    <div className="relative mb-3">
                                                        <span className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-500 text-sm">$</span>
                                                        <input
                                                            min={0}
                                                            max={1000}
                                                            className="w-full pl-7 pr-3 py-3 bg-slate-900/80 border border-slate-700 text-white text-lg font-semibold rounded-lg placeholder-slate-600 focus:border-blue-500 focus:ring-1 focus:ring-blue-500/50 transition-all tabular-nums"
                                                            type="number"
                                                            value={this.state.tradeAmount}
                                                            onChange={(e) => this.handleInputChange('tradeAmount', e.target.value)}
                                                            placeholder="0"
                                                        />
                                                    </div>

                                                    {/* Quick amount buttons */}
                                                    <div className="flex gap-1.5 mb-4">
                                                        {(this.state.tradeMode === 'buy'
                                                            ? [10, 25, 50, 100]
                                                            : [Math.floor(numSharesOwned * 0.25), Math.floor(numSharesOwned * 0.5), numSharesOwned].filter(v => v > 0)
                                                        ).map((amt) => (
                                                            <button
                                                                key={amt}
                                                                className="flex-1 py-1.5 text-xs font-medium text-slate-400 bg-slate-800/80 hover:bg-slate-700 rounded-md transition-colors"
                                                                onClick={() => this.handleInputChange('tradeAmount', amt)}
                                                            >
                                                                {this.state.tradeMode === 'sell' && amt === numSharesOwned ? 'All' : `$${amt}`}
                                                            </button>
                                                        ))}
                                                    </div>

                                                    {/* Submit */}
                                                    <button
                                                        className={`w-full py-3 text-sm font-semibold rounded-lg transition-colors ${
                                                            this.state.tradeMode === 'buy'
                                                                ? 'bg-emerald-500 hover:bg-emerald-600 disabled:bg-emerald-500/20 text-white'
                                                                : 'bg-red-500 hover:bg-red-600 disabled:bg-red-500/20 text-white'
                                                        } disabled:cursor-not-allowed`}
                                                        onClick={() => {
                                                            if (this.state.tradeMode === 'buy') {
                                                                this.setState({ numToBuy: this.state.tradeAmount }, () => this.attemptToIPOBuy());
                                                            } else {
                                                                this.setState({ numToSell: this.state.tradeAmount }, () => this.attemptToIPOSell());
                                                            }
                                                        }}
                                                        disabled={
                                                            isInvalidDate() ||
                                                            !this.props.data.currStock?.stockData ||
                                                            !this.state.tradeAmount ||
                                                            this.state.tradeAmount <= 0 ||
                                                            (this.state.tradeMode === 'buy' &&
                                                                this.state.tradeAmount * (this.props.data.currStock?.stockData?.ipoPrice || 0) > (this.props.user?.accountBalance || 0)) ||
                                                            (this.state.tradeMode === 'sell' &&
                                                                this.state.tradeAmount > numSharesOwned)
                                                        }
                                                    >
                                                        {this.state.tradeMode === 'buy' ? 'Buy' : 'Sell'} ${this.state.tradeAmount || 0}
                                                    </button>

                                                    {/* Points preview table — inside card, buy mode only */}
                                                    {this.state.tradeMode === 'buy' && (
                                                        <div className="mt-4 pt-3 border-t border-slate-800/50">
                                                            <div className="text-[10px] text-slate-600 text-center mb-2 uppercase tracking-wider">
                                                                Points if you {numSharesOwned > 0 ? 'add' : 'invest'} ${this.state.tradeAmount || 0}
                                                            </div>
                                                            <table className="w-full text-xs">
                                                                <thead>
                                                                    <tr className="border-b border-slate-800/50">
                                                                        <th className="text-left py-1.5 px-2 text-slate-500 font-medium">Round</th>
                                                                        <th className="text-right py-1.5 px-2 text-slate-500 font-medium">Points</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {new Array(7).fill(0).map((_, i) => {
                                                                        const totalShares = (Number(this.state.tradeAmount) || 0) + numSharesOwned;
                                                                        const pts = totalShares * i * (this.props.data.currStock?.stockData?.seed || 0);
                                                                        return (
                                                                            <tr key={i} className="border-b border-slate-800/20">
                                                                                <td className="py-1 px-2 text-slate-400">
                                                                                    {i}W — {getRoundName(64 / Math.pow(2, i))}
                                                                                </td>
                                                                                <td className={`py-1 px-2 text-right font-semibold tabular-nums ${pts > 0 ? 'text-blue-400' : 'text-slate-700'}`}>
                                                                                    {pts.toLocaleString()}
                                                                                </td>
                                                                            </tr>
                                                                        );
                                                                    })}
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    )}
                                                </div>
                                            </>
                                        )}
                                    </div>
                                ) : (
                                    <div className="text-center py-4">
                                        {this.props.user &&
                                        TOURNAMENT_NOT_STARTED &&
                                        !this.props.user.authenticated ? (
                                            <p className="text-sm text-slate-500">
                                                Log in to invest in this team.
                                            </p>
                                        ) : null}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

StockModal.propTypes = {
    user: PropTypes.object.isRequired,
    ui: PropTypes.object.isRequired,
    data: PropTypes.object.isRequired,
};
const mapStateToProps = (state) => ({
    user: state.user,
    ui: state.ui,
    data: state.data,
});

const mapActionsToProps = {
    setOwnedStocks,
    getCurrStock,
    // getTradesForCurrStock,
};

export default connect(mapStateToProps, mapActionsToProps)(StockModal);
